import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { Theme } from 'scripts/react-components/themes/Theme'

const wrapperStyles = ({ theme }: Theme) => css`
  label: wrapper;

  display: grid;
  margin-bottom: ${theme.spacings.mega};
  grid-gap: ${theme.spacings.mega};

  grid-template-columns: 1fr 1fr;

  ${theme.media.mega} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${theme.media.giga} {
    grid-template-columns: repeat(4, 1fr);
  }
`

export const Wrapper = styled('div')(wrapperStyles)
